/** Leading Material font icon for a submission-list status chip. */
export function getLeadingIcon(status: string): string {
  switch (status.toLowerCase()) {
    case 'draft':
      return 'edit';
    case 'pre-review':
    case 'review':
      return 'lock';
    case 'outcome':
    case 'complete':
      return 'check_circle';
    case 'todo':
    case 'onhold':
    case 'on_hold':
      return 'error';
    default:
      return '';
  }
}

/** Normalize "with wcg" text by trimming all spaces and underscores. */
export function normalizeWithWcgText(text: string): string {
  return text.toLowerCase().replace(/[\s_]+/g, '');
}

/** Display label for a submission-list status chip value. */
export function getStatusLabel(status: string): string {
  const normalizedStatus = status.toLowerCase();
  if (normalizeWithWcgText(normalizedStatus) === 'withwcg') {
    return 'With WCG';
  }
  switch (normalizedStatus) {
    case 'onhold':
    case 'on_hold':
      return 'Hold';
    case 'todo':
      return 'To Do';
    default:
      return status;
  }
}
